module.exports = __webpack_public_path__ + "img/he.008bf18a.jpg";